import { ABP, eLayoutType } from '@abp/ng.core';

/**
 * Árvore de menu do Leilão quando o tenant tem a feature Bolsao: o nó folha atual vira
 * pai (sem path — o clique navega via patch no app.component) com dois filhos no hover.
 * Tenant SEM a feature nunca chega aqui: a folha original (ofertas-abertas-base.route.ts)
 * permanece intocada. (Padrão herdado da retomada do Bolsão — 26/07/2026.)
 */
export const LEILAO_ARVORE_COM_BOLSAO: ABP.Route[] = [
  {
    name: 'Leilão',
    iconClass: 'fas fa-hammer',
    order: 0,
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.Ofertas',
  },
  {
    path: '/ofertas-abertas',
    name: 'Cargas Abertas',
    parentName: 'Leilão',
    iconClass: 'fas fa-list-ul',
    order: 0,
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.Ofertas',
  },
  {
    // Ampulheta = contratação antecipada aguardando a carga nascer (doc de melhorias do Bolsão,
    // item 1 — o pedido era "ampulheta com martelo", mas o menu renderiza UM glifo Font Awesome;
    // o martelo do leilão já mora no nó pai).
    path: '/bolsao',
    name: 'Bolsão',
    parentName: 'Leilão',
    iconClass: 'fas fa-hourglass-half',
    order: 1,
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.Bolsao',
  },
];
